import React, { useEffect, useState, useCallback } from "react";
import LogedInOutlet from "../outlets/LogedInOutlet";
import useLogout from "../hooks/useLogout";
import { useNavigate, Link } from "react-router-dom";
import Mainmenu from "./links/Mainmenu";
import "../pages/PublicNavbar.css";
import useAuth from "../hooks/useAuth";
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import Collapse from 'bootstrap/js/dist/collapse';

import { Toast, ToastContainer } from "react-bootstrap";


export default function SecuredLayout() {
  const navigate = useNavigate();
  const logout = useLogout();
  const { auth } = useAuth();

  const signOut = async () => {
    await logout();
    navigate("/login");
  };
  const role = auth?.roles || "Guest"; // fallback if roles undefined

  const collapseNavbar = () => {
    // Use setTimeout to ensure this runs *after* navigation
    setTimeout(() => {
      const navbarCollapse = document.getElementById('navbarNav');
      if (navbarCollapse && navbarCollapse.classList.contains('show')) {
        try {
          const bsCollapse = Collapse.getInstance(navbarCollapse) || new Collapse(navbarCollapse, { toggle: false });
          bsCollapse.hide();
        } catch (error) {
          console.error("Navbar collapse error:", error);
        }
      }
    }, 100); // short delay to avoid race condition
  };

  function ToastMessage({ message, show, onClose }) {
    return (
      <ToastContainer
        className="p-3"
        position="top-center"   // 🔹 move toast to top center
        style={{ zIndex: 9999 }} // make sure it's above other UI
      >
        <Toast
          onClose={onClose}
          show={show}
          bg={toastType === "error" ? "danger" : toastType === "warning" ? "warning" : "success"}
          autohide={toastType === "success"}   // ✅ success auto-hides, error/warning stay
          delay={3000}                         // auto-hide after 3s (only for success)
        >
          <Toast.Body className="text-white">{message}</Toast.Body>
        </Toast>

      </ToastContainer>
    );
  }
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success"); // success | error | warning
  const [showToast, setShowToast] = useState(false);


  useEffect(() => {
    const handleOnline = () => {
      setToastMessage("✅ Internet reconnected!");
      setToastType("success");
      setShowToast(true);
    };

    const handleOffline = () => {
      setToastMessage("🚨 You are offline!");
      setToastType("error");  // stays until reconnect
      setShowToast(true);
    };

    const checkInternetSpeed = async () => {
      const start = Date.now();
      try {
        await fetch("https://www.google.com/favicon.ico", { mode: "no-cors" });
        const duration = Date.now() - start;

        if (duration > 3000) {
          setToastMessage("⚠️ Internet is very slow...");
          setToastType("warning");  // stays until speed improves
          setShowToast(true);
        }
      } catch {
        setToastMessage("🚨 No internet connection!");
        setToastType("error");
        setShowToast(true);
      }
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    const interval = setInterval(checkInternetSpeed, 10000);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      clearInterval(interval);
    };
  }, []);


  return (

    <div className="">
      <div className="navbar navbar-expand-lg navbar-dark  mynavbar">
        <div className="container d-flex justify-content-between align-items-center">

          <img src="/images/newlogowhite.png" className="navimg" alt="Logo" style={{ height: '40px' }} />

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              {role === "Admin" ? (
                <li className="nav-item">
                  <Link to="/dashboard" className="nav-link active" onClick={collapseNavbar}>Dashboard</Link>
                </li>
              ) : role === "Arthiksakha" ? (
                <li className="nav-item">
                  <Link to="/ArthiksakhaDashboard" className="nav-link active" onClick={collapseNavbar}>Dashboard</Link>
                </li>
              ) : role === "Sthan" && auth.category ? (
                <li className="nav-item">
                  <Link to="/sthanDashboard" className="nav-link active" onClick={collapseNavbar}>Dashboard</Link>
                </li>
              ) : (
                <li className="nav-item">
                  {/* <Link to="/dashboard" className="nav-link active">Guest Dashboard</Link> */}
                </li>
              )
              }


              {!(
                (role === null && auth.category === null) ||
                (role === "Sthan" && auth.category === null)
              ) && (

                  <Mainmenu
                    group="Gurudakshina"
                    to="#"
                    className="nav-link dropdown-toggle active"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    onItemClick={collapseNavbar}
                  >
                    Gurudakshina
                  </Mainmenu>

                )}




              {!(
                (role === null && auth.category === null) ||
                (role === "Sthan" && auth.category === null)
              ) && (
                  <Mainmenu
                    group="Administration"
                    to="#"
                    className="nav-link dropdown-toggle active"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    onItemClick={collapseNavbar}
                  >
                    Administration
                  </Mainmenu>
                )}





              <li className="nav-item">
                <Link onClick={signOut} className="nav-link active"><span className="signoutc"><strong> <i className="bx bx-log-out icon dashiconnew"></i></strong> SignOut</span></Link>
              </li>
            </ul>
          </div>

        </div>
      </div>
      <ToastMessage
        message={toastMessage}
        show={showToast}
        onClose={() => setShowToast(false)}
      />

      <div>
        {/* <div className="p-8" style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}> */}
        <LogedInOutlet />
      </div>
    </div>
  );
}
